import classNames from 'classnames'
import React from 'react'
import {EventImage} from '../../../../event-image'
import s from './image.scss'
import {ImageProps} from './interfaces'

export const Image: React.FC<ImageProps> = ({fullWidth}) => (
  <EventImage className={classNames(s.imageContainer, {[s.minimized]: !fullWidth})} />
)
